var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("签到 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "p",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.dialogVisible = true
                }
              }
            },
            [_vm._v("发起签到")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", { staticStyle: { margin: "20px 0" } }, [_vm._v("签到记录")]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "签到人" } },
            [_c("tjkautocomplete", { on: { callBack: _vm.updateTjkId } })],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "发起签到时间" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "选择开始日期"
                },
                on: { change: _vm.changeHandlerStart },
                model: {
                  value: _vm.queryStartTime,
                  callback: function($$v) {
                    _vm.queryStartTime = $$v
                  },
                  expression: "queryStartTime"
                }
              }),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "选择结束日期"
                },
                on: { change: _vm.changeHandlerEnd },
                model: {
                  value: _vm.queryEndTime,
                  callback: function($$v) {
                    _vm.queryEndTime = $$v
                  },
                  expression: "queryEndTime"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "签到主题" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: { clearable: "" },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getExcel } },
                [_vm._v("导出")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, border: "", "highlight-current-row": "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "startTime", label: "发起签到时间", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "timeRule", label: "签到规则", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "签到主题", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "tjkNumber", label: "淘金号", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "tjkName", label: "签到人", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-popover",
                      { attrs: { trigger: "hover", placement: "right-start" } },
                      [
                        _c("p", [
                          _vm._v("真实姓名：" + _vm._s(scope.row.realName))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("淘金号：" + _vm._s(scope.row.tjkNumber))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "客服标签：" + _vm._s(scope.row.tjkTypeTagName)
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("所属团队：" + _vm._s(scope.row.providerName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [
                            _c("span", [_vm._v(_vm._s(scope.row.tjkName))]),
                            _vm._v(" "),
                            scope.row.tjkTypeTag === "ProviderService"
                              ? _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://taojinyun.file.itaojin.cn/tjkTypeIconTuan.png",
                                      width: "20px"
                                    }
                                  })
                                ])
                              : scope.row.tjkTypeTag === "SaleService"
                              ? _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://taojinyun.file.itaojin.cn/tjkTypeIconXiao.png",
                                      width: "20px"
                                    }
                                  })
                                ])
                              : scope.row.tjkTypeTag === "FreeService"
                              ? _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://taojinyun.file.itaojin.cn/tjkTypeIconZi.png",
                                      width: "20px"
                                    }
                                  })
                                ])
                              : scope.row.tjkTypeTag === "MerchantService"
                              ? _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://taojinyun.file.itaojin.cn/tjkTypeIconShang.png",
                                      width: "20px"
                                    }
                                  })
                                ])
                              : _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://taojinyun.file.itaojin.cn/tjkTypeIconYun.png",
                                      width: "20px"
                                    }
                                  })
                                ])
                          ]
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "checkInTime", label: "签到时间", align: "center" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
        on: { getData: _vm.getList }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "发起签到",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "modal",
              attrs: {
                model: _vm.modal,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "签到主题", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请控制在5个字内", clearable: "" },
                    model: {
                      value: _vm.modal.name,
                      callback: function($$v) {
                        _vm.$set(_vm.modal, "name", $$v)
                      },
                      expression: "modal.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "时间", prop: "time" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.modal.time,
                        callback: function($$v) {
                          _vm.$set(_vm.modal, "time", $$v)
                        },
                        expression: "modal.time"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "1",
                        attrs: { label: "1分钟内", value: "1" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        key: "3",
                        attrs: { label: "3分钟内", value: "3" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        key: "5",
                        attrs: { label: "5分钟内", value: "5" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        key: "60",
                        attrs: { label: "1小时内", value: "60" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addCheckIn } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55b1013d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55b1013d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/college/groupCheckIn.vue
// module id = 1194
// module chunks = 0